import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loader from 'components/shared/Loader';
import { getText, trackGA } from 'misc/helpers';
import * as types from 'misc/types';

class End extends Component {
    render = () => {
        return (
            <Loader>
                <div className="settings-view">
                    <h1>{getText('_3_2_TitelExitServiceAtDigimail', 'Avsluta Digimail')}</h1>
                    <p>
                        {getText(
                            '_6_4_text_ending_Digimail',
                            'Du har nu valt att avsluta din Digimail. Detta kommer leda till att du från och med nu inte kommer få några nya brev till din brevlåda. Du har däremot 90 dagar på dig att aktivera din digitala brevlåda igen, om du har ångrat dig eller vill hämta ut dina sparade brev. För att göra detta logga du in igen med ditt bankID. Glöm inte att du måste godkänna de allmänna villkoren om detta inte gjorts.\n\nOm du inte väljer att logga in kommer din brevlåda att raderas efter 90 dagar. '
                        )}
                    </p>

                    <button className="button-yellow button-big button-bankid" onClick={() => this.endAccount()}>
                        {getText('_6_4_button_ending_digimail', 'Avsluta Digimail')}
                    </button>
                </div>
            </Loader>
        );
    };

    endAccount() {
        const { sessions, dispatch } = this.props;
        dispatch({ type: types.SAGA_CUSTOMER_DELETE.REQUEST, customerId: sessions.data.customerId });
        
        trackGA('12.4 Avsluta');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        sessions: state.sessions,
    };
};

export default connect(mapStateToProps)(End);



// WEBPACK FOOTER //
// ./src/components/views/settings/End.js